export const TOAST = 9000;
export const MODAL = 10000;
